import { Box, Button, Text } from '@citibox-panel/ui';

export interface BoxStatusErrorStripProps {
  // Height of the slot the strip has to fill. Owned by the banner, which is what guarantees the four
  // states share one footprint — a strip free to pick its own would reintroduce the shift the
  // skeleton exists to prevent.
  slotHeight: number;
  onRetry: () => void;
}

// The degraded state of the «Aviso de estado del buzón»: the read failed and the notice cannot be
// resolved. Deliberately QUIETER than the notices it sits among — neutral border, secondary text, no
// severity colour — because red in that slot reads as a problem with the «Entrega» rather than with a
// read the agent can retry. `role="status"` and not `alert`: a failed read is not something the agent
// must be interrupted for, unlike the notice itself.
export function BoxStatusErrorStrip({ slotHeight, onRetry }: BoxStatusErrorStripProps) {
  return (
    <Box
      role="status"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        minHeight: slotHeight,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
        pl: 2,
        pr: 1,
      }}
    >
      {/* TODO: i18n */}
      <Text variant="body2" color="secondary">
        No se ha podido cargar el estado del buzón.
      </Text>
      <Button variant="text" onClick={onRetry}>
        Reintentar
      </Button>
    </Box>
  );
}
